import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import store from "./store/index";
import { Provider } from "react-redux";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense fallback="loading...">
        <App />
        <Toaster
          toastOptions={{
            position: "top-center", // Position of the toast in the middle of the screen
            duration: 6000, // Duration in milliseconds
            style: {
              borderRadius: "1px 8px 8px 1px",
              background: "#fefefe",
              color: "#282c34",
            },
            // Success toast style
            success: {
              duration: 7000,
              style: {
                border: "1px solid #4CAF50",
                borderLeft: "5px solid #4CAF50",
                background: "#fefefe",
                color: "#4CAF50",
              },
              iconTheme: {
                primary: "#4CAF50",
                secondary: "#FFFFFF",
              },
            },
            // Error toast style
            error: {
              duration: 9000,
              style: {
                border: "1px solid #E57373",
                borderLeft: "5px solid #E57373",
                background: "#fefefe",
                color: "#E57373",
              },
              iconTheme: {
                primary: "#E57373",
                secondary: "#FFFFFF",
              },
            },
            // Default toast style
          }}
        />
      </Suspense>
    </Provider>
  </BrowserRouter>
);
reportWebVitals();
